import { useState } from 'react';
import { useLazyQuestionnairesQuery } from '../../../graphql/graphql';

export default function useQuestionnaireOverview() {
	const [getQuestionnairesQuery, { data, isLoading }] =
		useLazyQuestionnairesQuery();
	const [page, setPage] = useState(1);

	const getFlatQuestionnaires = (filter: object) => {
		getQuestionnairesQuery({
			...filter,
			skip: (page - 1) * 10,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatQuestionnaires,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
